import { Button, ConfigProvider, Modal, Spin, Table, Tag } from 'antd'
import React, { createRef, useEffect, useState } from 'react'
import InvoiceCommissionPayment from '../../production/components/docs/InvoiceCommissionPayment'
import MultipleInvoicesCommissions from '../../production/components/docs/MultipleInvoicesCommissions'
import { displayNumbers } from '../../../variables/numbersFunctions'
import frFR from "antd/locale/fr_FR";
import { rightsService } from '../../../services/rightsService'
import axiosInstance from '../../../variables/api/axiosInstance'
import { useReactToPrint } from 'react-to-print'
import { CreditCardFilled, ExclamationCircleFilled, FilePdfFilled } from '@ant-design/icons'
import EditTauxCommissionContrat from './EditTauxCommissionContrat'

const { confirm } = Modal;

const CommissionsTab = ({ loadingContrats, commissions, handleChange, selecting, selectedContrat, selectedContrats, rowSelection, setSelectedContrat, hidden, setHidden, hiddenMultpleInvoices, sortedInfo, filteredInfo, selectedRows, setSelectedContrats, setHiddenMultipleInvoices }) => {

    const printInvoiceCommissionRef = createRef();
    const printMultipleInvoicesRef = createRef();

    const [editedTauxCommission, setEditedTauxCommission] = useState(0);
    const [editTauxCommissionOpenModal, setEditTauxCommissionOpenModal] = useState(0);
    const [modalModePaiement, setModalModePaiement] = useState(true);

    const handlePrint = useReactToPrint({
        content: () => printInvoiceCommissionRef.current,
    });

    const handleMultipleInvoicesPrint = useReactToPrint({
        content: () => printMultipleInvoicesRef.current,
    });

    const exportInvoiceCommissionPaymentToPdf = (contrat) => {
        console.log("The entire: ", contrat);
        setSelectedContrat(contrat);
        setHidden(true);
    };


    useEffect(() => {
        if (hidden) {
            handlePrint();
        }
        if (hiddenMultpleInvoices) {
            handleMultipleInvoicesPrint();
        }
    }, [hidden, hiddenMultpleInvoices, handleMultipleInvoicesPrint, handlePrint]);

    const exportToPdfs = (contrats) => {
        if (contrats.length === 1) {
            exportInvoiceCommissionPaymentToPdf(contrats[0]);
        } else {
            setSelectedContrats(contrats);
            // console.log("Contracts: ", contrats);
            setHiddenMultipleInvoices(true);
            handleMultipleInvoicesPrint();
        }
    };

    const MyFooter = () => {
        let ctrt = selectedRows.filter((ctr) => ctr.data.commissionPaye);
        let nCtrt = selectedRows.filter((ctr) => !ctr.data.commissionPaye);
        console.log("R: ", ctrt);
        // console.log("NR: ", nrCtrts);
        return (
            <div class="row">
                {!ctrt ? (
                    <div class="col-sm-4">
                        <Button
                            onClick={() => {
                                encaisserContrats(nCtrt);
                            }}
                            color="success"
                            icon={<CreditCardFilled />}
                            style={{
                                color: "red",
                            }}
                            title="Encaissement"
                        >
                            Encaisser
                        </Button>
                    </div>
                ) : (
                    <>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportToPdfs(ctrt);
                                }}
                                color="primary"
                                style={{ color: "green" }}
                                icon={<FilePdfFilled />}
                            >
                                Imprimer le reçu
                            </Button>
                        </div>
                    </>
                )}
            </div>
        );
    };

    const encaisserContrats = (cts) => {
        setModalModePaiement(true);
        // setContractsToPay(cts);
    };

    const commissionColumns = [
        {
            title: "N° Police",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Montant Prime",
            dataIndex: "primeNette",
            key: "4",
            render: (_, record) => (
                <>
                    {record.data.montant ? displayNumbers(
                        record.data.montant
                    ) : 0}
                </>
            )
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "5",
            render: (_, record) => (
                <>
                    {record.data.commission ? displayNumbers(
                        record.data.commission
                    ) : 0}
                </>
            )
        },
        {
            title: "Statut reglement",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.data.commissionPaye ? (
                        <Tag color="success" key={_}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="blue" key={_}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <>
                    {!record.data.commissionPaye && rightsService("HLA045") ? (
                        <>
                            <button
                                type="button"
                                class="btn btn-success btn-icon rounded-pill"
                                onClick={() => { showCommissionPaymentConfirm(record.data.codeId) }}
                            >
                                <i class="bx bxs-credit-card"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary btn-icon rounded-pill"
                                onClick={() => {
                                    setSelectedContrat(record.contrat);
                                    setEditedTauxCommission(record.data.tauxCommission);
                                    setEditTauxCommissionOpenModal(true);
                                }}
                            >
                                <i class="bx bxs-edit"></i>
                            </button>
                        </>
                    ) : rightsService("HLA046") && <button
                        type="button"
                        class="btn btn-danger btn-icon rounded-pill"
                        onClick={() => { exportInvoiceCommissionPaymentToPdf(record) }}
                    >
                        <i class="bx bxs-file-pdf"></i>
                    </button>}
                </>
            ),
        },
    ];

    const showCommissionPaymentConfirm = (contratId) => {
        confirm({
            title: "Etes-vous sûr de vouloir payer cette commission?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                commissionPayment(contratId);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const commissionPayment = (contratId) => {
        axiosInstance
            .get(`/api/reglement/commission-payment/${contratId}`)
            .then((res) => {
                // console.log(res.data);
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div>
            <div className="card-datatable table-responsive">
                <ConfigProvider locale={frFR}>
                    <Spin spinning={loadingContrats}>
                        <Table
                            rowSelection={rowSelection}
                            columns={commissionColumns}
                            dataSource={commissions}
                            onChange={handleChange}
                            footer={selecting ? () => <MyFooter /> : undefined}
                        />
                    </Spin>
                </ConfigProvider>
            </div>
            {hidden && (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '135vh', margin: 0, padding: 0 }}>
                    <InvoiceCommissionPayment ref={printInvoiceCommissionRef} contrat={selectedContrat} />
                </div>
            )}
            {hiddenMultpleInvoices && (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '205vh', margin: 0, padding: 0 }}>
                    <MultipleInvoicesCommissions ref={printMultipleInvoicesRef} contrats={selectedContrats} />
                </div>
            )}


            <EditTauxCommissionContrat editTauxCommissionOpenModal={editTauxCommissionOpenModal} setEditTauxCommissionOpenModal={setEditTauxCommissionOpenModal} selectedContrat={selectedContrat} editedTauxCommission={editedTauxCommission} setEditedTauxCommission={setEditedTauxCommission} />
        </div>
    )
}

export default CommissionsTab